export default __webpack_public_path__ + "static/media/cardIcon.c087aeba.png";